module.exports = __webpack_public_path__ + "img/ke.1c7b75b6.jpg";